import React, { Component } from "react";
import { Form, RadioGroup, Radio } from "informed";

import EditText from "./edit-text/EditText";
import RadioButton from "./radio/Radio";
import DropDownSearch from "./drop-down/DropDownSearch";
import EditPassword from "./edit-text/EditPassword";

// import "./FormStyles.css";

const validate = value => {
  return !value || value.length < 5
    ? "Field must be at least five characters"
    : null;
};

const creditCardNumberValidate = value => {
  value = value.replace(/\D/g, "");
  value = value.replace(/ /g, "");
  var val = "";

  if (value.length > 16) {
    value = value.substring(0, 16);
  }

  for (var i = 0; i < value.length; i++) {
    if ((i + 1) % 4 === 0 && i + 1 < value.length) val = val + value[i] + " ";
    else val = val + value[i];
  }

  return val;
};

const colourOptions = [
  { value: "ocean", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" }
];

const flavourOptions = [
  { value: "vanilla", label: "Vanilla" },
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "salted-caramel", label: "Salted Caramel" }
];

const groupedOptions = [
  {
    label: "Colours",
    options: colourOptions
  },
  {
    label: "Flavours",
    options: flavourOptions
  }
];

const colourStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: "white",

    height: 55,

    borderWidth: 1,
    borderColor: "#A6A6A6",
    borderRadius: 0,

    boxShadow: 0,

    fontWeight: 400,
    fontSize: 20,
    textDecoration: "none",
    color: "#333333"
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "#FFFFFF",
      color: "#000000",
      minHeight: 18
    };
  },
  input: styles => ({ ...styles }),
  placeholder: styles => ({
    ...styles,
    fontWeight: 400,
    fontSize: 20,
    color: "#999999"
  }),
  singleValue: (styles, { data }) => ({ ...styles })
};

export default class FormStyles extends Component {
  normalNote = () => {
    return (
      <div>
        <i
          className="fa fa-question-circle note-icon"
          style={{ color: "#0070C9" }}
        />
        Note: Your policy or premium may change due to your new address.
        Explanation and submission are available on the next page.
      </div>
    );
  };

  noteUL = () => {
    return (
      <div>
        <li>Coffee</li>
        <li>Tea</li>
        <li>Milk</li>
      </div>
    );
  };

  noteDownload = () => {
    return (
      <div className="d-flex flex-column">
        Downloading progress:
        <progress value="22" max="100" />
        <strong>Note:</strong>
        The progress tag is not supported in Internet Explorer 9 and earlier
        versions.
      </div>
    );
  };

  render() {
    return (
      <div className="col-10">
        <h1> H1 Styles </h1>
        <h2> H2 Styles</h2>
        <h3> H3 Styles</h3>
        <h4> H4 Styles</h4>
        <a href="/">Test Link</a> <br />
        Body Style
        <hr />
        <Form id="simple-form">
          <EditText
            required
            email
            field="login_email_address_place_holder"
            type="text"
            title="EditText Email Address with PlaceHolder"
            floatingTitle={false}
          />
          <hr />

          <DropDownSearch
            field="flavour"
            id="select-flavour"
            data={groupedOptions}
            styles={colourStyles}
            label="Single select"
          />
          <hr />

          <EditText
            required
            email
            field="login_email_address_floating_label"
            type="text"
            title="EditText Email Address with Floating Label"
            floatingTitle={true}
          />
          <hr />

          <EditText
            required
            email
            field="login_email_address_validation"
            type="text"
            title="EditText Email Address with Validation"
            validate={validate}
            validateOnChange
            validateOnBlur
          />
          <hr />

          <EditText
            required
            email
            field="login_email_address_note"
            type="text"
            title="Email Address with Note"
            note={this.normalNote()}
            onFocus={() => {}}
          />
          <hr />

          <EditText
            required
            email
            field="login_email_address_note_ul"
            type="text"
            title="Email Address with UL as Note"
            note={this.noteUL()}
          />
          <hr />

          <EditText
            required
            email
            field="login_email_address_note_Download"
            type="text"
            title="Email Address with download as Note"
            note={this.noteDownload()}
          />
          <hr />

          <EditPassword
            required
            id="login_password"
            field="password"
            type="password"
            title="Password"
            floatingTitle={true}
            secured={true}
          />
          <hr />

          <EditText
            required
            email
            field="Credit Card  Number"
            type="text"
            title="Credit Card  Number"
            floatingTitle={true}
            mask={creditCardNumberValidate}
          />
          <hr />

          <button className="button-primary" type="submit">
            PRIMARY Button
          </button>
          <hr />
          <button className="button-primary-plus" type="submit">
            PRIMARY_PLUS Button
          </button>
          <hr />
          <button className="button-secondary" type="submit">
            SECONDARY Button
          </button>
          <hr />
          <button className="button-link" type="submit">
            Link Button
          </button>
          <hr />

          <RadioGroup field="gender">
            <RadioButton title="Male" value="male" id="radio-male" />
            <RadioButton title="Female" value="female" id="radio-female" />
          </RadioGroup>

          <hr />
        </Form>
      </div>
    );
  }
}
